module.exports = __webpack_public_path__ + "static/media/7-10.2b56e63d.mp3";